import * as Arr from 'fp-ts/Array';
import { pipe } from 'fp-ts/lib/function';
import * as i from 'io-ts';
const Value = i.type({
    value: i.number,
    /** How this dimension is expressed - usually something like 'width', 'length', 'height', etc. */
    label: i.string,
    /** The units to be applied to the value - 'mm', 'cm', etc. */
    unit: i.string,
});
export const Dimension = i.partial({ x: Value, y: Value, z: Value });
// TODO: come up with a better way of comparing dimensions
export const compare = (a, b) => {
    const aDimensions = parseInt(`${a?.x?.value ?? 0}${a?.y?.value ?? 0}${a?.z?.value ?? 0}`);
    const bDimensions = parseInt(`${b?.x?.value ?? 0}${b?.y?.value ?? 0}${b?.z?.value ?? 0}`);
    return aDimensions > bDimensions ? 1 : -1;
};
export const equal = (a, b) => a?.x?.value === b?.x?.value && a?.y?.value === b?.y?.value && a?.z?.value === b?.z?.value;
/**
 *  create a string representation of a dimension in the form of `8mm x 10mm x 12mm`,
 *  in the order of x -> y -> z
 *  if components of the dimension are missing, they will be left out
 */
export const toString = (d) => pipe([d?.x, d?.y, d?.z], Arr.filter(component => component?.value !== undefined), Arr.map(component => `${component?.value}${component?.unit}`), Arr.intersperse(' x ')).join('');
export const componentToString = (d, componentKey) => {
    const component = d[componentKey];
    return component && `${component?.value}${component?.unit}`;
};
/**
 *  create a string representation of a dimension in the form of `8 x 10 x 12mm`, in the order of x -> y -> z
 *
 * if components of the dimension are missing, they will be left out
 */
export const toStringSingleUnit = (d) => {
    const unit = d?.x?.unit ?? d?.y?.unit ?? d?.z?.unit;
    const base = pipe([d?.x, d?.y, d?.z], Arr.filter(component => component?.value !== undefined), Arr.map(component => `${component?.value}`), Arr.intersperse(' x ')).join('');
    return `${base}${unit}`;
};
